/** Mutex global para evitar corridas paralelas de sync (especialmente OPFS/SQLite en web). No reentrante. */
let syncMutexChain: Promise<void> = Promise.resolve();

export async function withSyncMutex<T>(fn: () => Promise<T>): Promise<T> {
  const previous = syncMutexChain;
  let release!: () => void;
  syncMutexChain = new Promise<void>((resolve) => {
    release = resolve;
  });

  await previous;
  try {
    return await fn();
  } finally {
    release();
  }
}
